/* -- Generated File: Do Not Edit ------------------------------------------ */
export const zIndexes = {
  sidebar: 1000,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  dropdown: 1350,
  snackbar: 1400,
  tooltip: 1500,
};

export default zIndexes;
/* -- Generated File: Do Not Edit ------------------------------------------ */
